<template>
  <section class="section" id="products-panel">
    <div class="container">
      <b-loading
        :is-full-page="true"
        :active="isLoading || isLoadingCategories"
        :can-cancel="false"
      ></b-loading>

      <scale-products-title
        :scaleProductsQty="scaleProductsBase.length"
        @get-scale-products="getScaleProducts"
        @add-scale-product="addScaleProduct"
      />

      <h2
        v-if="scaleProductsBase.length === 0"
        class="subtitle has-text-centered"
      >
        {{ $t("scaleProducts.noScaleProdutcs") }}
      </h2>

      <scale-products-table
        v-else
        :scaleProducts="scaleProductsBase"
        @edit-scale-product="editScaleProduct"
      />

      <b-modal :active.sync="isScaleProductModalOpen">
        <scale-product-modal
          :scaleProductBeingEdited="scaleProductBeingEdited"
          @get-scale-products="getScaleProducts"
        />
      </b-modal>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import scaleProductsTitle from "./ScaleProductsTitle";
import scaleProductsTable from "./ScaleProductsTable";
import scaleProductModal from "./ScaleProductModal";

export default {
  mixins: [common],

  components: {
    scaleProductsTitle,
    scaleProductsTable,
    scaleProductModal
  },

  data() {
    return {
      isLoading: false,
      isLoadingCategories: false,
      isScaleProductModalOpen: false,
      scaleProductBeingEdited: {}
    };
  },

  computed: {
    ...mapGetters(["storeBeingManaged", "scaleProductsBase"])
  },

  methods: {
    getScaleProducts() {
      this.isLoading = true;
      this.$store
        .dispatch("getScaleProducts")
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    getCategories() {
      this.isLoadingCategories = true;
      this.$store
        .dispatch("getCategories")
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoadingCategories = false;
        });
    },

    addScaleProduct() {
      this.scaleProductBeingEdited = {};
      this.isScaleProductModalOpen = true;
    },

    editScaleProduct(scaleProduct) {
      this.scaleProductBeingEdited = scaleProduct;
      this.isScaleProductModalOpen = true;
    }
  },

  mounted() {
    this.getScaleProducts();
    this.getCategories();
  }
};
</script>

<style scoped>
.explanation {
  /* max-width: 800px; */
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 30px;
}
#products-panel {
  margin-top: 3rem;
  min-height: 94vh;
  padding: 2rem 1rem;
  background-color: hsl(0, 0%, 96%);
}
</style>
